import React, { useState } from 'react';
import { modelTypeMap, quickModelShowType } from '../../../../constants';
import CardShimmer from '../../CardShimmer';
import InnerMore from '../../InnerMore';
import ScrollListener from '../../ScrollListener';
import LoadMore from '../../../base/LoadMore';
import { setModelsModalState, useModelsModalState } from '../../../../store/state';
import { pageSize, useCateListFetch } from './fetchHander';
import { v4 } from 'uuid';
import { EmptyState } from '../../../base/modelLib/EmptyState';

const HotWrapper = (props) => {
  const { cols, modelType, ratio, menus, menuPath, setMenus } = props;
  const { loading, fetchList, fetchCollect } = useCateListFetch(menuPath, modelType);
  const hotModels = useModelsModalState('hotModels');
  const [loadmore, setLoadMore] = useState(false);

  const onModelScroll = async () => {
    const nextChild = hotModels.find((li) => !li.data?.id);
    if (nextChild?.total > 100 && nextChild?.list?.length === 0) return; // TODO 测试环境异常数据过滤
    if (loading || loadmore || !nextChild) return;
    setLoadMore(true);
    const data =
      nextChild.type === quickModelShowType.collection
        ? await fetchCollect({
            page: 1,
            pageSize,
            collectionId: nextChild.code,
            requestId: v4(),
            ...nextChild,
          })
        : await fetchList({
            modelType: modelTypeMap[modelType],
            page: 1,
            pageSize,
            requestId: v4(),
            tagCode: nextChild.code,
            ...nextChild,
          });
    const newHotModels = hotModels.map((item) => {
      if (item.code === nextChild.code) {
        return {
          ...item,
          data,
        };
      }
      return item;
    });
    setModelsModalState({
      hotModels: newHotModels,
    });
    setLoadMore(false);
  };

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }
  const hasData = (hotModels ?? []).some((li) => li?.data?.list?.length > 4);
  if (!hasData) return <EmptyState />;
  return (
    <ScrollListener className="flex flex-wrap pl-4 !h-auto" onScroll={() => onModelScroll()}>
      {(hotModels ?? []).map((item, idx) => {
        return item?.data ? <InnerMore data={item.data} key={idx} ratio={ratio} {...props} /> : null;
      })}
      {loadmore && <LoadMore />}
    </ScrollListener>
  );
};

export default HotWrapper;
